import {
  ChangeDetectorRef, ChangeDetectionStrategy, Component, Input,
  OnInit, OnDestroy, ViewChild
} from '@angular/core';
import * as _ from 'lodash';


import { SearchModel } from 'shared/search/search.model';

import { BrandService } from 'shared/brand/brand.service';
import { ExportScheduleManagerSearchService } from './export-schedule-manager-search.service';

import { SearchWidgetComponent } from 'shared/search-widget/search-widget.component';
import { HiddenScrollComponent } from 'shared/scroll/hidden-scroll/hidden-scroll.component';
import { LoaderComponent } from 'shared/loader/loader.component';
import {takeWhile} from 'rxjs/operators';
import {ProductPanelComponent} from '../../../product-panel/product-panel.component';


@Component({
  moduleId: module.id,
  selector: 'export-schedule-manager-search',
  templateUrl: 'export-schedule-manager-search.component.html',
  styleUrls: ['export-schedule-manager-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExportScheduleManagerSearchComponent extends SearchWidgetComponent implements OnInit, OnDestroy {

  @Input() sortingColumns: Array<any> = [];

  @Input() ghostValue: string = 'schedules';

  @ViewChild(HiddenScrollComponent, {static: true})
  hiddenScroll: HiddenScrollComponent | void;

  @ViewChild(LoaderComponent, {static: false})
  loader: LoaderComponent | void;

  private isActive: boolean = true;

  constructor(
    public searchService: ExportScheduleManagerSearchService,
    protected brandService: BrandService,
    private ref: ChangeDetectorRef,
  ) {
    super(
      brandService,
      searchService,
    );
  }

  /*******************************************
  * COMPONENT HOOKS
  *******************************************/

  ngOnInit() {
    this.searchModel = new SearchModel();
    this.initSubscriptions();
    _.defer(() => this.hiddenScroll && this.hiddenScroll.defineContentWidth());
  }

  ngOnDestroy() {
    this.destroySubscriptions();
    this.isActive = false;
  }

  /*******************************************
  * COMPONENT METHODS
  *******************************************/


  runSearch(searchModel: SearchModel) {
    if (this.loader) {
      this.loader.show();
    }
    this.ref.markForCheck();
    this.searchService.runSearch(this.brandService.getBrand(), searchModel)
    .pipe(takeWhile(() => this.isActive))
    .subscribe((res: any) => {
      if (this.loader) {
        this.loader.hide();
      }
      this.ref.markForCheck();
    });
  }

  updateSearch(): void {
    if (this.searchModel instanceof SearchModel) {
      this._searchModel.next(this.searchModel);
    }
  }

  reset(): void {
    this.searchService.deselectAll();
    this.searchService.searchResults = [];
    if (this.searchModel instanceof SearchModel) {
      this.searchModel.selectAll = 'on-page';
    }
  }
}
